import { MutationHookOptions } from '@apollo/client';

import { useMemberMutation } from '@frontend/app/hooks';
import { UPDATE_KLAVIYO_SYNC_SETTINGS } from '@frontend/app/queries';
import { UpdateKlaviyoSyncSettings, UpdateKlaviyoSyncSettingsVariables } from '../queries/types/UpdateKlaviyoSyncSettings';

type IOptions = MutationHookOptions<UpdateKlaviyoSyncSettings, UpdateKlaviyoSyncSettingsVariables>;

export const useUpdateKlaviyoSyncSettings = (options: IOptions = {}) => useMemberMutation<UpdateKlaviyoSyncSettings, UpdateKlaviyoSyncSettingsVariables>(UPDATE_KLAVIYO_SYNC_SETTINGS, options);
